export const items = [
    {
        label: 'Dla użytkowników',
        items: [
            {
                label: 'Jak to działa?',
                href: 'howToUse/index'
            },
            {
                label: 'Najczęściej zadawane pytania',
                href: 'usersQuestions/index'
            },
            {
                label: 'Mapa strony',
                href: '/SiteMap'
            },
            {
                label: 'Zalecane przeglądarki',
                href: '/zalecane-przegladarki'
            },
            {
                label: 'Regulamin',
                href: '/regulamin'
            },
            {
                label: 'Polityka prywatności',
                href: '/polityka-prywatnosci'
            },
            {
                label: 'Kontakt',
                itemOptions: {
                    class: 'button kontakt separated'
                },
                linkOptions: {
                    class: 'btn border'
                },
                href: '/kontakt'
            },
            {
                label: 'Akt o usługach cyfrowych',
                itemOptions: {
                    class: 'button'
                },
                linkOptions: {
                    class: 'btn border'
                },
                href: '/akt-uslugi-cyfrowe'
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Informacje dla sklepów',
                href: 'infoForShops/index'

            },
            {
                label: 'Obowiązek informacyjny',
                href: '/obowiazek-informacyjny'
            },
            {
                label: 'Raport Sklepów 2023',
                href: 'https://ranking.opineo.pl/'
            }
        ]
    },
    {
        label: 'Dla partnerów',
        items: [
            {
                label: 'Program Partnerski',
                href: 'https://panel.moneteasy.pl/login'
            },
            {
                label: 'Regulamin',
                href: 'termsPartnersProgram/index'
            },
            {
                label: 'FAQ - Program Partnerski',
                href: 'https://moneteasy.pl/wydawca#faq'
            },
            {
                label: 'API Skąpiec',
                href: 'apiSkapiec/index'
            }
        ]
    },
    {
        label: 'Firma Skąpiec.pl',
        items: [
            {
                label: 'O nas',
                href: '/o-nas'
            },
            {
                label: 'Centrum prasowe',
                href: '/site/doc/200'
            },
            {
                label: 'Praca',
                href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy'
            }
        ]
    },
    {
        label: 'Reklama',
        items: [
            {
                label: 'Informacje ogólne',
                href: 'reklama/index'
            }
        ]
    }
] as {
    label: string;
    items: {
        label: string;
        href: string;
        itemOptions?: {
            class: string;
        };
        linkOptions: {
            class: string;
        };
    }[];
}[];
